export default "__VITE_ASSET__CS6jq4Dh__"